// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"0ef9e1a8","2954":"58cdd2d0","3790":"a24fe7c3","3980":"a7532082","6884":"4532085d"}[chunkId] + ".chunk.css";
};